import React from "react";
import { LaserEngravingProps } from "@/types/laser-engraving";
import { LASER_ENGRAVING_DEFAULTS } from "@/lib/laser-physics";

// 导入子组件
import { CrystalContainer } from "./CrystalContainer";
import { PointCloud } from "./PointCloud";
import { IronManModel } from "./IronManModel";

/**
 * 激光内雕组合组件（重构后：纯渲染组件）
 *
 * 这是主要的组合组件，专注于渲染：
 * - 使用预处理的点云几何体和模型数据
 * - 不再调用任何数据获取hooks
 * - 清晰的单向数据流
 * - 职责单一：纯渲染组件
 */
export const LaserEngraving = React.memo<LaserEngravingProps>(
  ({
    position = LASER_ENGRAVING_DEFAULTS.position,
    rotation = LASER_ENGRAVING_DEFAULTS.rotation,
    scale = LASER_ENGRAVING_DEFAULTS.scale,
    displayMode,
    pointCloudConfig,
    crystalConfig,
    pointGeometry,
    processedModels,
    isLoading = false,
    error = null,
  }) => {
    console.log("🎯 LaserEngraving 渲染（重构后）", {
      displayMode,
      position,
      rotation,
      scale,
      crystalSize: crystalConfig.size,
      hasPointGeometry: !!pointGeometry,
      modelCount: processedModels.length,
      isLoading,
      error,
    });

    // 如果有错误，显示错误信息
    if (error) {
      console.error("🎯 LaserEngraving 错误:", error);
    }

    // 如果正在加载，可以显示加载指示器
    if (isLoading) {
      console.log("🎯 LaserEngraving 加载中...");
    }

    return (
      <group position={position} rotation={rotation} scale={scale}>
        {/* 🎯 水晶阴影层 - 独立的阴影投射层，与点云完全隔离 */}
        <group name="crystalShadowLayer">
          <CrystalContainer
            shellConfig={crystalConfig}
            castShadow={true}
            receiveShadow={true}
          />

          {displayMode === "pointCloud" && (
            <group name="pointCloudLayer">
              <PointCloud
                geometry={pointGeometry}
                config={pointCloudConfig}
                visible={true}
              />
            </group>
          )}

          {displayMode === "model" && (
            <IronManModel models={processedModels} visible={true} />
          )}
        </group>
      </group>
    );
  },
);

LaserEngraving.displayName = "LaserEngraving";

export default LaserEngraving;
